import { useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

export function usePopover() {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  // added to remove console warning
  // close on navigation to prevent aria-hidden being set on the popover root
  // while the paper element still holds focus during teardown
  useEffect(() => {
    if (open) {
      document.activeElement?.blur();
      setOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const handleOpen = useCallback(() => {
    document.activeElement?.blur();
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    document.activeElement?.blur();
    setOpen(false);
  }, []);

  const handleToggle = useCallback(() => {
    document.activeElement?.blur();
    setOpen((prevState) => !prevState);
  }, []);

  return {
    anchorRef,
    handleClose,
    handleOpen,
    handleToggle,
    open,
  };
}
